/** Lifecycle + status enums shared across the app. Stored as strings in DynamoDB. */
/**
 * Lead lifecycle. "Cold" is set automatically by the reminder pipeline after
 * 30 days with no enrollment (3 nudges sent, no response) - distinct from the
 * manual "Dropped" so owners can tell "lost to silence" from "we closed it".
 */
export const PROSPECT_STATUSES = ["New", "Contacted", "Enrolled", "Dropped", "Cold"];
/** Delivery state of the per-course auto-email for a prospect. */
export const EMAIL_STATUSES = ["pending", "sent", "failed", "bounced", "complained"];
/** Follow-up actions owners log against a prospect. */
export const FOLLOWUP_KINDS = ["called", "texted", "emailed", "reminder_sent", "note"];
/** IDPH workflow (manual, owner-updated). Draft → Authorized → Pending Exam → Passed | Failed. */
export const IDPH_STATUSES = ["Draft", "Authorized", "Pending Exam", "Passed", "Failed"];
/** Up to 3 exam attempts; a Fail with attempts remaining stays "Pending Exam". */
export const MAX_EXAM_ATTEMPTS = 3;
export const PAYMENT_STATUSES = ["Pending", "Partial", "Paid"];
/** Per-week homework submission lifecycle (weeks 1-4; labs have no status).
 * "Reviewed" is the admin acknowledgement of a submitted week; it supersedes
 * "Submitted" in displays. */
export const HOMEWORK_STATUSES = ["Assigned", "Submitted", "Overdue", "Reviewed"];
/** Student lifecycle (Phase 1b admin dashboard). Owner-updated. */
export const STUDENT_STATUSES = ["Enrolled", "In Progress", "Graduated", "Withdrawn"];
/** Monthly batch lifecycle. */
export const BATCH_STATUSES = ["Upcoming", "Active", "Completed"];
/** Result of a single IDPH exam attempt. */
export const EXAM_RESULTS = ["Pass", "Fail"];
/** Safe variables allowed in editable per-course auto-email templates. */
export const EMAIL_TEMPLATE_VARIABLES = [
    "first_name",
    "course_name",
    "course_details",
    "next_start",
    "fee",
    "brochure_link",
];
//# sourceMappingURL=enums.js.map